import React from 'react';
import {
  ArchitectureOutlined,
  CategoryOutlined,
  InsightsOutlined,
  ScienceOutlined,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import { Desc, Title } from './index.styles';
import FormAssumptions from './forms/assumptions';
import ProductCharacteristics from './forms/product-characteristics';
import Materials from './forms/materials';
import { useTranslation } from 'react-i18next';
import SectionCard from './SectionCard';
import EnvironmentalAdditionalData from './forms/environmental-additional-data';
import { emptyProductForm } from '../utils';

interface Props {
  values: typeof emptyProductForm;
  setValues: Function;
}

export default function LcaInfo({ setValues, values }: Props) {
  const { t } = useTranslation('lca', { keyPrefix: 'lcaInformation' });
  const sections = [
    {
      key: 'productCharacteristics',
      title: t('productCharacteristics'),
      subtitle: t('sectionDescriptions.productCharacteristics'),
      icon: <ArchitectureOutlined sx={{ color: '#7e4308' }} />,
      content: <ProductCharacteristics values={values} setValues={setValues} />,
    },
    {
      key: 'materialComposition',
      title: t('materialComposition'),
      subtitle: t('sectionDescriptions.materialComposition'),
      icon: <CategoryOutlined sx={{ color: '#7e4308' }} />,
      content: (
        <Materials
          values={values}
          setValues={setValues as (_nextValues: any) => void}
        />
      ),
    },
    {
      key: 'assumptions',
      title: t('assumptions'),
      subtitle: t('sectionDescriptions.assumptions'),
      icon: <ScienceOutlined sx={{ color: '#7e4308' }} />,
      content: <FormAssumptions values={values} setValues={setValues} />,
    },
    {
      key: 'environmentalData',
      title: t('environmentalData.title'),
      subtitle: t('sectionDescriptions.environmentalData'),
      icon: <InsightsOutlined sx={{ color: '#7e4308' }} />,
      content: (
        <EnvironmentalAdditionalData values={values} setValues={setValues} />
      ),
    },
  ];

  return (
    <div>
      <Title>{t('title')}</Title>
      <Desc>{t('desc')}</Desc>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', xl: '1fr 1fr' },
          gap: '24px',
          mt: '40px',
          alignItems: 'start',
        }}
      >
        {sections.map((section) => (
          <SectionCard
            key={section.key}
            icon={section.icon}
            title={section.title}
            subtitle={section.subtitle}
          >
            {section.content}
          </SectionCard>
        ))}
      </Box>
    </div>
  );
}
